import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class ToasterService {
  private _messageService = inject(MessageService);

  showSuccess(message: string): void {
    this._messageService.add({ severity: 'success', summary: 'Success', detail: message });
  }

  showError(message: string): void {
    this._messageService.add({ severity: 'error', summary: 'Error', detail: message });
  }

  showWarning(message: string): void {
    this._messageService.add({ severity: 'warn', summary: 'Warning', detail: message });
  }

  showInfo(message: string): void {
    this._messageService.add({ severity: 'info', summary: 'Info', detail: message });
  }
}
